import { Grid, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => ({
  sequenceEntryTitleStyle: {
    borderBottom: `1px solid ${theme.palette.grey[500]}`,
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  requiredText: {
    fontSize: theme.typography.pxToRem(12),
  },
}))

interface SequenceEntryHeaderProps {
  title: ReactNode
  showRequired?: boolean // default true
  titleContainerProps?: React.ComponentProps<typeof Grid>
}

const SequenceEntryHeader: React.FC<SequenceEntryHeaderProps> = ({
  title,
  showRequired = true,
  titleContainerProps,
}) => {
  const classes = useStyles()

  return (
    <Grid item container xs={12}>
      <Grid
        item
        xs={12}
        className={classes.sequenceEntryTitleStyle}
        {...titleContainerProps}
      >
        <Typography variant="h2">{title}</Typography>
      </Grid>
      {showRequired && (
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.requiredText}>
            *
            <FormattedMessage
              id="REQUIRED_FIELDS"
              defaultMessage="Required Fields"
            />
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default SequenceEntryHeader
